import type {PriceExtra} from './PriceExtra';
import type {PriceValueType} from './PriceValueType';

export type CommonPriceAttribute = {
  code: 'price';
  readonly type?: 'price';
  readonly title?: string;
  value: PriceValueType | null;
  readonly defaultValue?: PriceValueType | null;
  readonly displayValue?: PriceValueType | null;
  readonly extra?: PriceExtra;
  readonly required?: boolean;
  override: boolean;
  readonly hasPublishControl?: boolean;
  publish: boolean;
};
